function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import paginationEffect from '@/utils/paginationEffect';
import { Debounce } from '@/utils/validate';
import { homeApi } from '../../../../components/js/api';
export default {
  name: 'InterfaceTwo',
  props: {
    propsData: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return _objectSpread({
      goodsList: [],
      loading: false
    }, paginationEffect(this.getGoodsList));
  },
  watch: {
    propsData: {
      handler: function handler() {
        this.getGoodsList();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    imgError: function imgError(index) {
      this.$set(this.goodsList[index], 'image', require('@/assets/imgs/moren.jpg'));
    },
    getIds: function getIds() {
      var _this$propsData$showC, _this$propsData$label;
      switch (this.propsData.goodsType) {
        case 1:
          return (_this$propsData$showC = this.propsData.showCateId) === null || _this$propsData$showC === void 0 ? void 0 : _this$propsData$showC.join(',');
        case 2:
          return (_this$propsData$label = this.propsData.labelId) === null || _this$propsData$label === void 0 ? void 0 : _this$propsData$label.join(',');
        case 3:
          return this.propsData.skuId;
        default:
          return '';
      }
    },
    getGoodsList: function getGoodsList() {
      var _this = this;
      try {
        this.loading = true;
        var params = _objectSpread(_objectSpread({}, this.pageData), {}, {
          limit: 4,
          type: this.propsData.goodsType || 1,
          ids: this.getIds()
        });
        homeApi(params).then(function (res) {
          _this.goodsList = res.list || [];
          _this.loading = false;
        }).catch(function (err) {
          _this.loading = false;
        });
      } catch (error) {}
    }
  }
};